export class ServiceUrlConstants {

  // Auth endpoints
  public static readonly API_AUTH_SSO_LOGIN: string = '/auth/sso'
  public static readonly API_AUTH_TOKEN_REFRESH: string = '/auth/token/refresh'
  public static readonly API_AUTH_LOGOUT: string = '/auth/logout'

  // Dashboard endpoints
  public static readonly API_GET_DASHBOARD_INFO: string = '/dashboard/info'
  public static readonly API_ADHOC_BANKING_INFO_LOAD: string = '/adhoc/load-banking-info'
  public static readonly API_ADHOC_PROCESS_EXPENSES: string = '/adhoc/process-expenses'

  // Expense endpoints
  public static readonly API_EXPENSE = '/expense'
  public static readonly API_EXPENSE_LIST: string = ServiceUrlConstants.API_EXPENSE + '/list'
  public static readonly API_EXPENSE_PAYMENTS_HISTORY_BY_EXPENSE_ID: string = '/expense/{0}/{1}/status/list'
  public static readonly API_EXPENSE_REPORT_LIST: string = ServiceUrlConstants.API_EXPENSE + '/report/list'

  // Employee endpoints
  public static readonly API_EMPLOYEE_BANKING_INFO: string = '/employee/{0}/banking-info'

  // Execution logs endpoints
  public static readonly API_EXECUTION_LOG_LIST: string = '/execution-log/list'

  // File endpoints
  public static readonly API_FILE_EXPENSE_REPORT_DOWNLOAD: string = '/file/expense/report/{0}'
  public static readonly API_FILE_DOWNLOAD: string = '/file/{0}/download'
  public static readonly API_FILE_REPOST: string = '/file/{0}/repost'
}
